import {css} from 'styled-components';

/**
 * The helper add transition
 * @param {string} delay
 * @param {string} timingFunction
 * @return {
 *   FlattenInterpolation<ThemedStyledProps<{}, AnyIfEmpty<DefaultTheme>>>
 * }
 */
export default function transition(
    delay?: string,
    timingFunction?: string,
) {
  return css`
    transition: ${({theme: {variables}}) => `
      ${delay || variables.transitionDelay} ${timingFunction || variables.transitionTimingFunction}
    `};
  `;
}
